import type { StatusTone } from '@/components/data-table/columns-helper';

export function memberStatusTone(status?: string | null): StatusTone {
  switch (status) {
    case 'active':
      return 'success';
    case 'inactive':
      return 'muted';
    case 'suspended':
      return 'warning';
    case 'blacklisted':
      return 'danger';
    default:
      return 'default';
  }
}
